import { FoodsToggleButton, FoodsToggleButtonType } from "@foodpilot/foods";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { UnitSwitcher } from "src/components/Score/UnitSwitcher.tsx";
import { ScoreWithVariation } from "src/services/ScoreService";

export type ScatterHeaderProps = {
    scoreWithVariation: ScoreWithVariation;
    buttonChoices: FoodsToggleButtonType[];
    visualisationChoiceIndex: number;
};

export const ScatterHeader = (props: ScatterHeaderProps) => {
    const { t } = useTranslation();
    const { scoreWithVariation, buttonChoices, visualisationChoiceIndex } = props;

    return (
        <Box sx={{ borderBottom: "1px solid #E7E6E4" }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" padding="2rem">
                <Stack direction="row" alignItems="center" gap="20px">
                    <Typography variant="h3">{scoreWithVariation.group}</Typography>
                    <UnitSwitcher score={scoreWithVariation} />
                </Stack>
                <Stack direction="row" alignItems="center" gap="1rem">
                    <Typography variant="h5">{t("view_according_to")}</Typography>
                    <FoodsToggleButton
                        buttons={buttonChoices}
                        initialSelected={buttonChoices[visualisationChoiceIndex]}
                        buttonGroup={true}
                    />
                </Stack>
            </Stack>
        </Box>
    );
};
